import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28882b12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "notifications-view",
  class: "notifications-vuew mt-1"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-md-stretch" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "p-5 rounded-3 mb-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cursor-pointer btn btn-outline-danger float-end",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteWorkspaceModal"
}, "Delete Workspace", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Notifications", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "EMAIL" }, "E-Mail", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "WEBHOOK" }, "Webhook", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("We will send you emails whenever something has changed in the wording on your targeted websites. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please enter an email address where we should send the notifiaction to."),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label text-light"
}, "E-Mail ", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600" }, [
  /*#__PURE__*/_createTextVNode("We will send a request to the url whenever something has changed in the wording on your targeted websites."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("The "),
  /*#__PURE__*/_createElementVNode("i", { class: "text-gray-600" }, "diff*"),
  /*#__PURE__*/_createTextVNode(" variables represent a rendering of the first 5 changes in an html/markdown/text view. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("A queryselector will manuipulate the raw html data, so all variables will be effected by the selector."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", { class: "text-gray-800" }, "Variables:"),
  /*#__PURE__*/_createElementVNode("i", { class: "text-gray-600" }, " url, link, text, raw, markdown, diff, preview (Preview image of the current diff)"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label text-black"
}, "Url", -1))
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label text-black"
}, "HTTP Headers (optional)", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label text-black"
}, "Method", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "post" }, "POST", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "put" }, "PUT", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label text-black"
}, "Payload", -1))
const _hoisted_32 = {
  key: 2,
  class: "text-danger text-small mt-2 mb-1"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteWorkspaceModal = _resolveComponent("DeleteWorkspaceModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _withDirectives(_createElementVNode("select", {
              class: "mt-4 mb-4 form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notificationType) = $event))
            }, _hoisted_10, 512), [
              [_vModelSelect, _ctx.notificationType]
            ]),
            (_ctx.notificationType == 'EMAIL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "email",
                      placeholder: "example@gmail.com",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email.address) = $event)),
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.email.address]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.notificationType == 'WEBHOOK')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "url",
                      placeholder: "https://hooks.slack.com/services/T00000000/B00000000/XXXXXXXXXXXXXXXXXX",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.webhook.url) = $event)),
                      onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.webhook.url]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhook.headers, (value, name) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: name,
                          class: "header-row"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.webhook.headers[name].key) = $event),
                            placeholder: "Key",
                            class: "form-control"
                          }, null, 8, _hoisted_22), [
                            [_vModelText, _ctx.webhook.headers[name].key]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.webhook.headers[name].value) = $event),
                            placeholder: "Value",
                            class: "form-control"
                          }, null, 8, _hoisted_23), [
                            [_vModelText, _ctx.webhook.headers[name].value]
                          ]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteHeader(name)),
                            class: "btn btn-outline-danger btn-small"
                          }, "-", 8, _hoisted_24)
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addHeader && _ctx.addHeader(...args))),
                        class: "btn btn-outline-primary"
                      }, "+")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.webhook.method) = $event))
                    }, _hoisted_29, 512), [
                      [_vModelSelect, _ctx.webhook.method]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _withDirectives(_createElementVNode("textarea", {
                      class: "text-dark",
                      rows: "5",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.webhook.payload) = $event))
                    }, "\n                                ", 512), [
                      [_vModelText, _ctx.webhook.payload]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.errorMsg), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "mt-4 btn btn-black",
              type: "button",
              disabled: _ctx.testing,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.test && _ctx.test(...args)))
            }, _toDisplayString(!_ctx.testing ? 'Test' : 'Sending notification....'), 9, _hoisted_33),
            _createElementVNode("button", {
              class: "mt-4 btn btn-outline-light float-end",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
              type: "button",
              disabled: _ctx.submitted
            }, _toDisplayString(!_ctx.submitted ? 'Update' : 'Updating...'), 9, _hoisted_34),
            _hoisted_35
          ])
        ])
      ])
    ]),
    _createVNode(_component_DeleteWorkspaceModal)
  ]))
}